import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { FlexColumn } from "../../../../../../Common/Styles";

export const YouAreAboutToSubmit = () => {
  const { typography, Color } = useTheme();
  const style = { tokenStyle: typography.Body.M };

  return (
    <Container>
      <Components.Text
        style={{ tokenStyle: typography.Body.L }}
        text="You’re about to submit a report"
        fontWeight="font-weight-semibold"
      />
      <div>
        <Components.Text
          style={style}
          text="We only remove content that goes against our "
        />
        <Components.Text
          style={style}
          text="Community Standards."
          color={Color.text["text-link"].value}
          isLink={true}
          onLinkClick={() => {
            // TODO implement link click for community standards
          }}
        />
        <Components.Text
          style={style}
          text=" You can review or edit your report details below."
        />
      </div>
    </Container>
  );
};
const Container = styled(FlexColumn)(
  ({ theme }) => `
  padding: ${theme.spacing["spacing-2"].value}rem;
  border-radius: ${theme.radius["radius-xs"].value}rem;
  gap: ${theme.spacing["spacing-2"].value}rem;
  background: ${theme.Color.elevation.surface["surface-secondary"].value};
`
);
